import { ChatHeader } from "../../../components/chat/chat-header";
import { Box, Button, Typography } from "@mui/material";
import { mockMessages } from "../moked-messages/mock-messages";
import MessageBubble from "../../../components/chat/chat-bubble/message-bubble";
import { MessageFooter } from "../../../components/chat/message-footer/message-footer";
import { OnboardingArrowRightIcon } from "../../../assets/icon";
import { DotsIndicator } from "../dots-indicator-onboarding/dots-indicator-onboarding";
import { UserDropdownMenu } from "../../../components/user-dropdown-menu/user-dropdown-menu";
import { motion } from "framer-motion";

interface MenuOnboardingProps {
  handlePrevPage: () => void;
  handleNextPage: () => void;
  handleSkip: () => void;
}

export const MenuOnboarding = ({
  handlePrevPage,
  handleNextPage,
  handleSkip,
}: MenuOnboardingProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100dvh",
        background: "linear-gradient(180deg, #50557033 0%, #505570 100%)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", position: "relative" }}>
        <ChatHeader onLogout={() => {}} onMessageSelect={() => {}} />
        <Box
          sx={{ position: "relative", maxWidth: "1100px", margin: "0 auto" }}
        >
          <Box sx={{ position: "absolute", top: "100%", right: 0 }}>
            <motion.div
              initial={{ opacity: 0, y: -100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 1, y: -50 }}
              transition={{
                delay: 0.5,
                type: "spring",
                stiffness: 150,
                damping: 10,
              }}
            >
              <UserDropdownMenu
                isStatic
                anchorEl={null}
                isOpen={true}
                onClose={() => {}}
                onLogout={() => {}}
                onStatisticOpen={() => {}}
                onSettingsOpen={() => {}}
                onRecordingsOpen={() => {}}
                onChatInfoOpen={() => {}}
              />
            </motion.div>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: -2,
          pointerEvents: "none",
          filter: "blur(3px)",
        }}
      >
        <Box
          sx={{
            maxWidth: "1000px",
            margin: "0 auto",
            paddingX: "10px",
            marginTop: "120px",
          }}
        >
          {mockMessages.map((msg, index) => (
            <MessageBubble
              key={msg.message_id}
              message={msg}
              isBot={msg.is_bot}
              bubbleIndex={index}
              headerVisible={false}
              prevMessageHeight={0}
              scrollToPreviousUserMessage={() => {}}
              scrollToNextUserMessage={() => {}}
              scrollToPreviousLessonMessage={() => {}}
              scrollToNextLessonMessage={() => {}}
            />
          ))}
          <MessageFooter
            onSendMessage={() => {}}
            onRecordAudio={() => {}}
            onFileChange={() => {}}
            isUploading={false}
            isUploadingFile={false}
          />
        </Box>
      </Box>

      <Box
        sx={{
          background: "#FFFFFF",
          borderRadius: "40px",
          maxWidth: "670px",
          padding: { xs: "36px 16px", md: "48px 144px" },
          margin: { xs: "8px", md: "30px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Typography
            sx={{
              color: "#0E0E0E",
              fontSize: { xs: "32px", md: "40px" },
              fontWeight: 700,
            }}
          >
            Menu Panel
          </Typography>
          <Typography
            sx={{
              color: "#84909F",
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            Use the{" "}
            <Box component="span" sx={{ color: "#06B6D4" }}>
              Top Menu
            </Box>{" "}
            for general settings and interaction management (favorites, lessons,
            tags, and more)
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginY: "32px",
          }}
        >
          <Button
            onClick={handleNextPage}
            sx={{
              background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: "999px",
              px: "32px",
              py: "16px",
              "&:hover": {
                background: "linear-gradient(90deg, #20B6C8 0%, #7C4ABF 100%)",
              },
            }}
          >
            {"Next"}
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            marginTop: { xs: "10px", sm: "12px" },
            marginBottom: { xs: "8px", sm: "10px" },
            paddingX: { xs: "8px", sm: "12px" },
          }}
        >
          <OnboardingArrowRightIcon
            style={{ width: "30px", cursor: "pointer" }}
            onClick={handlePrevPage}
          />
          <DotsIndicator activeIndex={7} />
          <Typography
            onClick={handleSkip}
            sx={{
              fontSize: { xs: "14px", sm: "16px" },
              color: "#B6BAD5",
              cursor: "pointer",
            }}
          >
            Skip
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
